import { Col, Container, Row } from "reactstrap";
import { H4, Image } from "../../AbstractElements";
import { dynamicImage } from "../../Service";
import { useAuth } from "../../context/AuthContext";

const SamplePageContainer = () => {
  const { user } = useAuth();
  const name = user?.name || "Faseen";

  return (
    <>
      <Container fluid className="home-panel-container">
        <Row className="home-panel-row">
          <Col xs="12" className="home-panel-col">
            <H4 className="home-panel-title">Welcome {name} !</H4>
            <div className="home-panel-hero">
              <Image
                className="home-panel-hero-image"
                src={dynamicImage("banner-image.png")}
                alt="HtSol hero"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SamplePageContainer;
